module.exports = __webpack_public_path__ + "img/wygl3.e2bbca1b.png";